export const GmRewardActionsEnum = {
  STATUS_UP_CARD: 'status-up-card',
  LEVEL_UP_CARD: 'level-up-card',
  OPEN_SUPPORT: 'open-support',
  GM_REWARD_REDEEM_INSTRUCTION: 'gm-reward-redeem-instruction',
  OPEN_REFERRAL_PAGE: 'open-referral-page',
  FREE_SPINS: 'free-spins',
} as const;
